import React from 'react'
import { connect } from 'react-redux'
import { Flex, Box, Drawer, DrawerContent, DrawerOverlay, DrawerBody } from '@chakra-ui/react'

import { onCloseSideNav } from 'redux/actions/app.actions'
import SideNavContent from './sub/SideNavContent'
import { CloseButton } from '@chakra-ui/react'

function SideNav({ isOpenSideNav, onCloseSideNav }) {
  return (
    <Flex as="nav">
      <Box
        boxShadow="lg"
        bg="brand.front"
        display={{ base: 'none', md: 'block' }}
        pos="fixed"
        top="0"
        left="0"
        bottom="0"
        w="var(--side-nav-width)"
        transition="width .325s ease"
        zIndex="5"
        overflow="hidden auto"
        data-tour="side-nav"
      >
        <SideNavContent />
      </Box>
      <Drawer
        autoFocus={false}
        isOpen={isOpenSideNav}
        placement="left"
        onClose={onCloseSideNav}
        returnFocusOnClose={true}
        onOverlayClick={onCloseSideNav}
        size="xs"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerBody>
            <CloseButton
              color="#fff"
              onClick={onCloseSideNav}
              pos="absolute"
              top="8px"
              right="16px"
              zIndex="30" />
            <SideNavContent isMobile={true} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  )
}

const mapStateToProps = state => {
  return {
    isOpenSideNav: state.app.isOpenSideNav
  }
}

export default connect(mapStateToProps, { onCloseSideNav })(SideNav)
